import { cn } from '@core/utils';
import type { ToastContainerProps } from 'react-toastify';
import { Slide, ToastContainer } from 'react-toastify';

type ToastProviderProps = Omit<ToastContainerProps, 'transition'>;

export const ToastProvider = ({
  className,

  position = 'bottom-center',
  draggable = true,
  ...restProps
}: ToastProviderProps) => {
  return (
    <ToastContainer
      draggable={draggable}
      stacked
      className={cn('p-0', className)}
      closeButton={false}
      draggableDirection="y"
      draggablePercent={20}
      position={position}
      theme="colored"
      toastClassName={cn(
        '!min-h-0 cursor-grab !bg-[rgba(0,0,0,0.7)] backdrop-blur-sm',
        'whitespace-pre-line rounded-pill px-20 py-12 font-400 !text-Gray-white typo-body4',
        'w-full overflow-hidden break-words',
      )}
      transition={Slide}
      {...restProps}
    />
  );
};
